
import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VeeValidate, { Validator } from "vee-validate";
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'

 Validator.extend("ip", {
        getMessage: () => "Please enter a valid IP address",
        validate: value => {
          const ipv4 = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          const ipv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::1)$/;
          return ipv4.test(value) || ipv6.test(value);
        }
      })

export default{
    name: 'ReleasePrinter',
    components: {
        VueElementLoading,
        Multiselect
      },
    data:function(){
        return{
            printerIPAddress:'',
            isLoading:false,
            input:{},
            hub_id:'',
            userid:'',
            releasePrinterConfirmationModel : false,
            hubloader:'',
            hublist:[],
            hubitem: {
                value: '',
                text: ''
              },
            hubname:'',
            hubnameerror:'',
            lastmodifiedby:''
            

        }
            
    },
    mounted(){
        this.$refs.printerIPAddress.focus();
            var userdetailEncrypt = window.localStorage.getItem('userdetail')
            var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            var userdetail = JSON.parse(plaintext)
            this.userid = userdetail[0].userid;
            this.lastmodifiedby = userdetail[0].email;
            this.getHubList();
        
    },
    computed: {
        isFormInvalid() {
            const ipEmpty = !this.printerIPAddress; 
            const printerIpInvalid = this.errors.has('printerIPAddress');
            const hubInvalid = !this.hubitem || !this.hubitem.value;
            return hubInvalid || printerIpInvalid||ipEmpty;
          }
      },
   
    methods:{
     releasePrinter(){
        this.isLoading=true
        this.input = {
         hub_id:this.hub_id,
         ip_address:this.printerIPAddress,
         user_id:this.userid,
         lastmodifiedby:this.lastmodifiedby
        }
        axios({
            method:"POST",
            url: apiUrl.api_url_hubops + 'printers/releasePrinter',
            data:this.input
        })
        .then(result=>{
            if(result.data.ResultCode == 100){
                this.$alertify.success("Printer Released Successfully")
            }
            else if (result.data.ResultCode != 100){
                this.$alertify.error(result.data.ReturnMessage)
            }
            this.releasePrinterConfirmationModel = false;
            this.isLoading=false
        }).catch((e)=>{
            this.isLoading=false;
            this.$alertify.error("Something went wrong, please try again later")
            this.releasePrinterConfirmationModel = false;
        })

     },
     getHubList() {
        this.input = ({})
        this.hubloader = 'Loading Hub...'
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.hubloader = ''
            var HubDetails = result.data.ResponseData
            for (var i = 0; i < HubDetails.length; i++) {
              this.hublist.push({
                "value": HubDetails[i].HubID,
                "text": HubDetails[i].HubName,
              })
            }
          }, error => {
            console.log(error)
            this.$alertify.error("Unable to fetch hubs")
          })
      },
      setSelectedHub(hubitem) {
        this.hub_id = hubitem.value;
        this.hubname = hubitem.text;
        this.hubitem = hubitem;
        if (this.hubname == '') {
          this.hubnameerror = 'Select Hub Name'
        } else {
          this.hubnameerror = ''
        }
      },
     releasePrinterConfirmation(){
        if (this.isFormInvalid) {
            this.$alertify.error("Please fill all required fields correctly");
            return;
          }
        
          this.releasePrinterConfirmationModel = true;
        },
     cancelReleasePrinter(){
        this.releasePrinterConfirmationModel = false;
     },
     resetData(){
        this.printerIPAddress = '';
        this.isLoading=false,
        this.releasePrinterConfirmationModel =false,
        this.$validator.reset();
        this.hubitem= {
            value: '',
            text: ''
          }
     }

    }
    
}


// WEBPACK FOOTER //
// ./src/views/components/ReleasePrinter/releasePrinter.js